class FreeShippingProgressHeader extends HTMLElement {
  connectedCallback() {
    this.requestId = 0;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    // Every cart change (add, quantity change, remove, free sample) publishes cartUpdate.
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
  }

  refresh() {
    const requestId = ++this.requestId;

    fetch(`${routes.cart_url}?section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // Ignore responses that arrive after a newer request was started.
        if (requestId !== this.requestId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const source = html.querySelector('[data-free-shipping-progress]');
        const target = this.querySelector('[data-free-shipping-progress]');
        if (!source || !target) return;

        const previousHeight = this.offsetHeight;
        target.replaceWith(source);

        // The bar appears/disappears when the cart goes from empty to non-empty,
        // so let the sticky header recalculate --header-height.
        if (this.offsetHeight !== previousHeight) {
          window.dispatchEvent(new Event('resize'));
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

if (!customElements.get('free-shipping-progress-header')) {
  customElements.define('free-shipping-progress-header', FreeShippingProgressHeader);
}
